import { render, staticRenderFns } from "./PlacementTypePicker.vue?vue&type=template&id=21e5ce04&lang=pug&"
import script from "./PlacementTypePicker.vue?vue&type=script&lang=js&"
export * from "./PlacementTypePicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports